import useDashboardTranslation from "../../../../../dashboard-translation/hooks/dashboard-translation-hook";
import { observer } from "mobx-react";
import { DefaultModalLayout } from "../../../../../components/modal/layouts/default-modal-layout";
import { BUTTON_VARIANTS } from "../../../../../components/inputs/button-variants";
import FontHeading4 from "../../../../../components/fonts/font-heading4/font-heading4";
import { IOption, SelectDropdown } from "../../../../../components/inputs/select-dropdown/select-dropdown";
import { FormFieldLine } from "../../../../../components/form-field-line/form-field-line";
import ListLayout from "../../../../../components/layouts/list-layout/list-layout";
import FontBody2 from "../../../../../components/fonts/font-body2/font-body2";
import { FONT_COLOR } from "../../../../../components/fonts/font-props";
import { CUSTOMER_COLUMN_USE, RETURNS_DATE_FIELD } from "../../../../../services/api/ui-settings-service";
import uiSettingsStore from "../../../../../stores/ui-settings-store";
import { SingleValue } from "react-select";
import rmaPagedListStore from "../../stores/rma-paged-list-store";

interface IProps {
    onClose: () => void,
}

const RmaListSettingsPopup: React.FC<IProps> = observer(({ onClose }) => {
    const scope = 'dashboard-returns-table-settings';
    const { getTranslation } = useDashboardTranslation();

    const customerDisplayModOptions = [
        {
            label: getTranslation('CUSTOMER_ID', scope),
            value: CUSTOMER_COLUMN_USE.ID
        },
        {
            label: getTranslation('CUSTOMER_NAME', scope),
            value: CUSTOMER_COLUMN_USE.NAME
        },
    ];

    const customerDisplayModeValue = customerDisplayModOptions.find(option => option.value === uiSettingsStore.returnsCustomerDisplayMode);
    const onCustomerDisplayModeChange = (value: SingleValue<IOption>) => {
        uiSettingsStore.setReturnsCustomerDisplayMode(value?.value as CUSTOMER_COLUMN_USE);
    }

    const dateTypeOptions = [
        {
            label: getTranslation('RMA_CREATED', scope),
            value: RETURNS_DATE_FIELD.CREATED
        },
        {
            label: getTranslation('SHIPMENT_DELIVERED', scope),
            value: RETURNS_DATE_FIELD.DELIVERED
        },
        {
            label: getTranslation('SHIPMENT_IN_TRANSIT', scope),
            value: RETURNS_DATE_FIELD.SHIPPED
        },
    ];

    const dateTypeValue = dateTypeOptions.find(option => option.value === uiSettingsStore.returnsDateField);
    const onDateTypeChange = (value: SingleValue<IOption>) => {
        uiSettingsStore.setReturnsDateField(value?.value as RETURNS_DATE_FIELD);
    }
    const onSaveClick = async () => {
        rmaPagedListStore.resetIsLoaded();
        await uiSettingsStore.save();
        onClose();
        rmaPagedListStore.load();
    }
    return (
        <DefaultModalLayout
            buttons={[
                {
                    onClick: onClose,
                    variant: BUTTON_VARIANTS.Secondary,
                    text: getTranslation('CANCEL', scope),
                    disabled: uiSettingsStore.isSaving()
                },
                {
                    onClick: onSaveClick,
                    variant: BUTTON_VARIANTS.Primary,
                    text: getTranslation('SAVE', scope),
                    hasLoader: true,
                    isLoading: uiSettingsStore.isSaving(),
                    disabled: !uiSettingsStore.hasChanges()
                },
            ]}
            onCloseClicked={onClose} 
            isCloseDisabled={uiSettingsStore.isSaving()}
        >
            <ListLayout>
                <FontHeading4>{getTranslation('TITLE', scope)}</FontHeading4>
                <FormFieldLine
                    label={getTranslation('DATE_COLUMN', scope)}
                    note={getTranslation('DATE_DESCRIPTION', scope)}
                >
                    <SelectDropdown
                        options={dateTypeOptions}
                        value={dateTypeValue}
                        onChange={onDateTypeChange}
                        disabled={uiSettingsStore.isSaving()}
                    />
                </FormFieldLine>
                <FormFieldLine
                    label={getTranslation('CUSTOMER_COLUMN', scope)}
                    note={getTranslation('CUSTOMER_DESCRIPTION', scope)}
                    tooltip={<div className="rma-list-settings-popup-customer-tooltip">
                        <FontBody2 color={FONT_COLOR.NEUTRAL_WHITE}>
                            {getTranslation('CUSTOMER_TOOLTIP', scope)}
                        </FontBody2>
                    </div>}
                >
                    <SelectDropdown
                        options={customerDisplayModOptions}
                        value={customerDisplayModeValue}
                        onChange={onCustomerDisplayModeChange}
                        disabled={uiSettingsStore.isSaving()}
                    />
                </FormFieldLine>
            </ListLayout>
        </DefaultModalLayout>
    );
});


export default RmaListSettingsPopup;
